// extracted by mini-css-extract-plugin
module.exports = {"benefits":"Benefits_benefits__tcltX"};